/**
 * Common functions and variables.
 * @author  Park Lam
 */

/**
 * Usage:
 * Code: "helloworld".startsWith("hell")
 * Result: true
 */
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (str) {
        return this.substring(0, str.length) === str;
    };
}

/**
 * Usage:
 * Code: "{0} is the {1} {2}.".format("Park Lam", "most", "handsome guy")
 * Result: "Park Lam is the most handsome guy."
 */
if (!String.prototype.format) {
    String.prototype.format = function () {
        if (arguments.length === 0) return this;
        var args = arguments;
        return this.replace(/\{(\d+)\}/g, function (match, number) {
            return typeof args[number] != 'undefined' ? args[number] : match;
        });
    };
}

/**
 * Usage:
 * Code: "    content here     ".trim();
 * Result: "content here"
 */
if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/gm, '');
    };
}

/**
 * Usage:
 * a = ["a", "b"]
 * b = ["a", "b"]
 * a.equals(b) == true
 */
if (!Array.prototype.equals) {
    Array.prototype.equals = function (array) {
        if (!array) {
            return false;
        }

        if (this.length != array.length) {
            return false;
        }

        for (var i = 0, l = this.length; i < l; i++) {
            if (this[i] instanceof Array && array[i] instanceof Array) {
                if (!this[i].equals(array[i])) {
                    return false;
                }
            } else if (this[i] != array[i]) {
                return false;
            }
        }
        return true;
    };
}

/**
 * Usage:
 * ["key1", "value2", "key3", "value4"].filter(
 *      function(item, index, arr) {
 *          return item.startsWith("value");
 *      });
 * Result: ["value2", "value4"]
 */
if (!Array.prototype.filter) {
    Array.prototype.filter = function (func) {
        if (this === 0 || this === null || typeof func != "function") {
            throw new TypeError();
        }

        var t = this;
        var len = t.length;

        var res = [];
        var thisp = arguments[1];
        for (var i = 0; i < len; i++) {
            if (i in t) {
                var val = t[i];
                if (func.call(thisp, val, i, t)) {
                    res.push(val);
                }
            }
        }

        return res;
    };
}
/**
 * Usage:
 * ["key1", "value2", "key3", "value4"].foreach(
 *      function(item, index, arr) {
 *          console.info(item);
 *      });
 * Result:  "key1"
 *          "value2"
 *          "key3"
 *          "value4"
 */
if (!Array.prototype.foreach) {
    Array.prototype.foreach = function (func) {
        if (this === 0 || this === null || typeof func != "function") {
            throw new TypeError();
        }

        var t = Object(this);
        var len = t.length;

        var thisp = arguments[1];
        for (var i = 0; i < len; i++) {
            if (i in t) {
                var val = t[i];
                func.call(thisp, val, i, t);
            }
        }
    };
}
/**
 * Usage:
 * ["key1", "value2", "key3", "value4"].choice(2);
 * Result:  ["value4", "key1"]
 */
if (!Array.prototype.choice) {
    Array.prototype.choice = function (count) {
        if (count > this.length) {
            count = this.length;
        }

        var copy = this.concat([]);
        var result = [];
        while (result.length < count) {
            result.concat(copy.splice(codepku.randint(0, copy.length - 1), 1));
        }
        return result;
    };
}

/**
 * Usage:
 * Array.isArray([]); // true
 * Array.isArray({}); // false
 */
if (!Array.isArray) {
    Array.isArray = function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
}

/**
 * Usage:
 * Date.now()
 * Result: Current timestamp in milliseconds.
 */
if (!Date.now) {
    Date.now = function () {
        return +(new Date());
    };
}
window.codepku = {};
(function () {
    var _codepku = {};
    window.codepku = _codepku;
    /**
     * Purify object. Keep only properties.
     * Usage:
     * codepku.purify(window.location)
     */
    _codepku.purify = function (o) {
        return JSON.parse(JSON.stringify(o));
    };

    /**
     * Override 'typeof' function. It solved the typeof([]) returns 'object' problem.
     * Usage:
     * codepku.typeOf([]); // returns: 'array'
     */
    _codepku.typeOf = function (o) {
        return Object.prototype.toString.call(o).slice(8, -1).toLowerCase();
    };

    /**
     * Redirect to url.
     * Usage:
     * codepku.redirect("https://www.codepku.com/");
     */
    _codepku.redirect = function (url) {
        // for IE compatible
        setTimeout(function () {
            window.location.href = url;
        }, 0);
    };

    /**
     * Usage:
     * codepku.query("https://www.codepku.com/?debug=1&email=support@codepku.com");
     * result: "debug=1&email=support@codepku.com"
     */
    _codepku.query = function (url) {
        return url.replace(/^[^\?]+\??/, "");
    };

    /**
     * Usage:
     * codepku.parse("draft=1&debug=1&name=testcase");
     * result: { draft: "1", debug: "1", name: "testcase" }
     */
    _codepku.parse = function (q) {
        var params = {};
        q.split("&").foreach(
            function (item, index, arr) {
                item = item.split("=");
                key = item[0].trim();
                value = item[1].trim();
                if (params.hasOwnProperty(key)) {
                    if (Array.isArray(params[key])) {
                        params[key].push(value);
                    } else {
                        params[key] = [params[key], value];
                    }
                } else {
                    params[key] = value;
                }
            });
        return params;
    };

    /**
     * Get parameter by name from current views url query.
     *
     * Usage:
     * Page URL: https://www.example.com/?email=admin@example.com
     * var email = codepku.getUrlParameter("email");
     */
    _codepku.getUrlParameter = function (name) {
        return decodeURIComponent((new RegExp('[?|&]{0}=([^&;]+?)(&|#|;|$)'.format(name)).exec(window.location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    };

    /**
     * Get parameter by name from current views url hash.
     *
     * Usage:
     * Page URL: https://www.example.com/#email=admin@example.com
     * var email = codepku.getUrlSegment("email");
     */
    _codepku.getUrlSegment = function (name) {
        return decodeURIComponent((new RegExp('[#|&]{0}=([^&;]+?)(&|#|;|$)'.format(name)).exec(window.location.hash) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    };

    /**
     * Redirect to HTTPS automatically if current protocol is HTTP.
     *
     * Usage:
     * codepku.forceHttps();
     */
    _codepku.forceHttps = function () {
        if (window.location.protocol != 'https:') {
            codepku.redirect('https:' + window.location.href.substring(window.location.protocol.length));
        }
    };

    /**
     * Get value by name from cookie.
     *
     * Usage:
     * var token = codepku.getCookie("token", "default_value_here");
     */
    _codepku.getCookie = function (name) {
        if (typeof name !== 'string') {
            throw new TypeError();
        }
        return (document.cookie.split(';').filter(function (item, index, arr) {
            return item.trim().split('=').shift() == name;
        }).shift() || "").split('=').pop();
    };

    /**
     * Set value to cookie.
     *
     * Usage:
     * codepku.setCookie("token", "token_value", 7);
     */
    _codepku.setCookie = function (name, value, days) {
        if (typeof name !== 'string') {
            throw new TypeError();
        }
        document.cookie = "{0}={1};expires={3};path=/".format(name.trim(), (value || "").trim(), new Date(Date.now() + days * 24 * 3600 * 1000).toUTCString());
    };

    /**
     * Generate random integer in range.
     *
     * Usage:
     * ingcrations.randint(10, 20);
     */
    _codepku.randint = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    /**
     * Utilities for dictionary
     */
    _codepku.dict = {};
    _codepku.dict.clone = function (obj) {
        if (obj == null || typeof obj != "object") {
            return obj;
        }
        var copy = obj.constructor();
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                copy[attr] = obj[attr];
            }
        }
        return copy;
    };

    _codepku.dict.merge = function () {
        var obj = {};
        for (var i = 0; i < arguments.length; i++) {
            if (arguments[i] == null) {
                continue;
            }
            for (var key in arguments[i]) {
                obj[key] = arguments[i][key];
            }
        }
        return obj;
    };

    _codepku.dict.strip = function (obj, properties) {
        if (obj == null || !Array.isArray(properties)) {
            throw new TypeError();
        }
        for (var i = 0; i < properties.length; i++) {
            if (obj.hasOwnProperty(properties[i])) {
                delete obj[properties[i]];
            }
        }
        return obj;
    };

    _codepku.dict.select = function (obj, properties) {
        if (obj == null || !Array.isArray(properties)) {
            throw new TypeError();
        }
        var result = {};
        for (var i = 0; i < properties.length; i++) {
            if (obj.hasOwnProperty(properties[i])) {
                result[properties[i]] = obj[properties[i]];
            }
        }
        return result;
    };

    // AMD: Asynchronous Module Definition (AMD) API
    // refer to https://github.com/amdjs/amdjs-api/wiki/AMD
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {
        define(function () {
            return _codepku;
        });
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = _codepku;
    } else {
        window.codepku = _codepku;
    }

    /*
    * 判断是否为正整数
    * */
    _codepku.dict.isInteger = function (number) {
        return Math.round(number) == number;
    };

    /*
    * 判断字符串是否有特殊字符
    * */
    _codepku.dict.checkNotSpecialChar = function (params) {
        var reg = new RegExp("^([\\u4e00-\\u9fa5]|([A-Za-z])|([0-9]))*$");
        if (reg.test(params)) {
            return true;
        }
        return false;
    };

    /**
     * 用于校验用户名，孩子姓名，客户姓名可以有特殊字符\的情况
     * */
    _codepku.dict.checkCustomerName = function (params) {
        var reg = new RegExp("^([\\u4e00-\\u9fa5]|([A-Za-z])|([0-9])|\\\\)*$");
        if (reg.test(params)) {
            return true;
        }
        return false;
    };

    /*
    * 判断字符是否为空
    * */
    _codepku.dict.isNull = function (param) {
        if (param === null || param === undefined || param === '') {
            return true;
        }
        return false;
    };

    /*
    * 校验电话号码
    * */

    _codepku.dict.validateMobileNumber = function (phone) {
        if (phone) {
            return RegExp("^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[0-9])\\d{8}$")
                .test(phone);
        } else {
            return false;
        }
    };

    /*校验电话号码和座机号*/
    _codepku.dict.validateMobile = function (phone) {
        if (phone) {
            return (/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/).test(phone);
        } else {
            return false;
        }
    };

    /*
    * 秒转化为小时分钟
    * */
    _codepku.dict.formatSeconds = function (value) {
        if (value > 0) {
            var secondTime = parseInt(value);
            var minuteTime = 0;
            var hourTime = 0;
            if (secondTime > 60) {
                minuteTime = parseInt(secondTime / 60);
                secondTime = parseInt(secondTime % 60);
                if (minuteTime > 60) {
                    hourTime = parseInt(minuteTime / 60);
                    minuteTime = parseInt(minuteTime % 60);
                }
            }
            var result = parseInt(secondTime) + "秒";
            if (minuteTime > 0) {
                result = parseInt(minuteTime) + "分" + result;
            }
            if (hourTime > 0) {
                result = parseInt(hourTime) + "小时" + result;
            }
            return result;
        } else {
            return 0;
        }
    };

    /*
    * 取最大值并向上取整
    * */
    _codepku.dict.max = function (data) {
        return Math.ceil(Math.max.apply(Math, data));
    };
    _codepku.dict.min = function (data) {
        return Math.floor(Math.min.apply(Math, data));
    };
    /*
    if(_codepku.getUrlParams('debug') != '1') {
        _codepku.forceHttps();
    }
    */

    /*获取多层数组嵌套的属性值*/
    function isPlainObj(obj) {
        return Object.prototype.toString.call(obj) === '[object Object]';
    }

    function canTravers(obj) {
        return isPlainObj(obj) || Array.isArray(obj);
    }

    function solve(obj, key) {
        const res = [];
        if (isPlainObj(obj)) {
            const temp = [];
            for (let [_key, value] of Object.entries(obj)) {
                if (_key === key) {
                    res.push(value);
                }
                if (_key !== key && canTravers(value)) {
                    temp.push(value);
                }
            }
            temp.length && [].push.apply(res, solve(temp, key));
        } else {
            for (let i = 0; i < obj.length; i++) {
                if (canTravers(obj[i])) {
                    [].push.apply(res, solve(obj[i], key));
                }
            }
        }
        return res;
    }

    _codepku.dict.getKeyFromArr = function (arr, key) {
        const res = arr.reduce((acc, cur) => {
            let val;
            (canTravers(cur)) && (val = solve(cur, key));
            val && [].push.apply(acc, val);
            return acc;
        }, []);
        return res;
    };

    // 格式化当前时间  2019/02/13
    _codepku.curentTime = function () {
        let now = new Date();
        let year = now.getFullYear();       //年
        let month = now.getMonth() + 1;     //月
        let day = now.getDate();            //日

        let clock = year + "/";

        if (month < 10)
            clock += "0";

        clock += month + "/";

        if (day < 10) {
            clock += "0";
        }

        clock += day + "";
        return (clock);
    };

    // 获取随机数
    _codepku.sum = function (m, n) {
        let sum_num = Math.floor(Math.random() * (m - n) + n);
        return sum_num;
    };

}).call(this);
export default codepku;



// WEBPACK FOOTER //
// ./src/js/codepku.js